var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel__actions"},[_c('router-link',{staticClass:"btn",attrs:{"to":"/dodaj-wpis"}},[_vm._v("Dodaj wpis")]),_c('router-link',{staticClass:"btn",attrs:{"to":"/nieruchomosci"}},[_vm._v("Zobacz wpisy")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }